// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607301604/js/" + chunkId + "." + {"44":"de3b07ae","225":"ac8bdb31","481":"1b524cfa","486":"c0c7a0d7","770":"f8113cee"}[chunkId] + ".0.144134744979038.chunk.js";
};